var o=function(o,r){if(!o){var n="LD: "+(r||"unknown violation");if("production"!==process.env.NODE_ENV)throw new Error(n);console.error(n)}};export{o as invariant};
